import { defineMessages } from "react-intl";

export default defineMessages({
  message: {
    id: "accounts.ReconnectAuthenticationModal.message",
    defaultMessage:
      "At least one of your promotional properties has been disconnected due to invalid authentication. Reconnect your properties to keep your property data up to date.",
  },
});
